import { parseAthletesOrganizationInfoToClientList } from "../../../utils/user-helpers";
import { getAthleteFromId, getAthleteInfo } from "./task-constants";

const AddEditTasksController = async ({
  res,
  req,
  locals,
  api,
  flash,
  session,
  load,
}) => {
  const { body } = req;
  const { activeUser, organizationRoleName } = locals;
  try {
    const isAllowToLoadAllAthletes =
      organizationRoleName &&
      (organizationRoleName === "Admin" || organizationRoleName === "Owner");

    let filterGroupQuery = "";
    if (isAllowToLoadAllAthletes) {
      await load("allAthletesFromOrganization");
      filterGroupQuery = `&organizationCoach=${body.coachTask}&filterGroup=organization`;
    }

    const athletes = locals.allAthletesFromOrganization
      ? parseAthletesOrganizationInfoToClientList(
          locals.allAthletesFromOrganization
        )
      : activeUser.athletes;

    const athlete = await getAthleteFromId(body.athlete, athletes);
    delete body.athlete;
    if (athlete) {
      body.athlete = athlete._id;
      body.athleteInfo = getAthleteInfo(athlete);
    }
    await api("tasks", { method: "POST", body });
      res.redirect(
        `/coaching-portal/tasks?tab=${body.type}${filterGroupQuery}`
      );
  
  } catch (e) {
    console.error("error", e);
    flash("error", e.message);
    res.redirect("/actions/refresh");
  }
};

export default AddEditTasksController;
